export const QSTAT_DASHBOARD_REFRESH_MS = 10000;
const EMPTY_BAR_CHART = { labels: [], data: [] };
const SUMMARY_COLORS = {
    Answered: '#059669',
    Abandoned: '#ef4444',
    'Exit With Timeout': '#f59e0b',
    Online: '#059669',
    Away: '#eab308',
};
function summaryToBarChart(items) {
    if (!Array.isArray(items) || items.length === 0) {
        return { ...EMPTY_BAR_CHART };
    }
    const rows = items
        .filter((item) => !!item && typeof item === 'object' && 'label' in item)
        .map((item) => ({
        label: String(item.label ?? ''),
        count: Number(item.count) || 0,
    }))
        .filter((item) => item.label);
    return {
        labels: rows.map((row) => row.label),
        data: rows.map((row) => row.count),
        colors: rows.map((row) => SUMMARY_COLORS[row.label] ?? '#36A2EB'),
    };
}
function normalizeQueue(raw) {
    if (!raw || typeof raw !== 'object') {
        return null;
    }
    const q = raw;
    const name = String(q.name ?? q.queueName ?? '').trim();
    if (!name) {
        return null;
    }
    return {
        name,
        totalAvailableAgents: Number(q.totalAvailableAgents ?? q.totalAvailableAgent) || 0,
        totalActiveCalls: Number(q.totalActiveCalls) || 0,
        members: Array.isArray(q.members) ? q.members : [],
    };
}
/** Map CRM `/api/qstat/dashboard` payload to UI-friendly analytics. */
export function normalizeQstatDashboardAnalytics(raw) {
    const data = raw && typeof raw === 'object' ? raw : {};
    const queues = Array.isArray(data.queues)
        ? data.queues.map(normalizeQueue).filter((q) => q !== null)
        : [];
    const totalActiveAgents = Number(data.totalActiveAgents) || 0;
    const totalActiveCalls = Number(data.totalActiveCalls) || queues.reduce((sum, q) => sum + q.totalActiveCalls, 0);
    return {
        totalQueues: queues.length,
        totalActiveAgents,
        totalActiveCalls,
        asteriskConnected: Boolean(data.asteriskConnected),
        incomingCalls: summaryToBarChart(data.incomingCallsSummary),
        outgoingCalls: summaryToBarChart(data.outgoingCallsByDisposition),
        agents: summaryToBarChart(data.agentStatusSummary),
        queues,
    };
}
